import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button, type ButtonSizes } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import { addParams } from '@xing-com/xing-tracking';

const pickMediaQuery = ({ size }: { size: ButtonSizes }): string => {
  return size === 'small' ? mediaTopBarHidden : mediaTopBarVisible;
};

export const StyledButtonSmallWhenTopBar = styled(Button)<{
  size: ButtonSizes;
}>`
  @media ${pickMediaQuery} {
    display: none;
  }
`;

export const CreateJobButton: React.FC = () => {
  const { formatMessage } = useIntl();
  const targetURL = 'https://www.xing.com/recruiting/jobs/create';
  const trackingURL = addParams(targetURL, { nwt_nav: 'boneyard_job_ad' });
  const commonProps = {
    'data-testid': 'styled-create-job-button',
    to: trackingURL,
    variant: 'primary' as const,
  };

  return (
    <>
      <StyledButtonSmallWhenTopBar {...commonProps} size="small">
        {formatMessage({ id: 'MAINNAV_CREATE_JOB' })}
      </StyledButtonSmallWhenTopBar>
      <StyledButtonSmallWhenTopBar {...commonProps} size="medium">
        {formatMessage({ id: 'MAINNAV_JOBS_EASY_CREATE' })}
      </StyledButtonSmallWhenTopBar>
    </>
  );
};
